import React from 'react'

import { InterSvgIcon } from 'components'

import { Text } from '@interco/inter-ui/components/Text'

import { ButtonContainer, IconAndNameContainer } from '../styles/PrivacyPolicyButton.styles'
import { TPrivacyPolicyButton } from '../types/PrivacyPolicyButton.types'

export const PrivacyPolicyButtonView = ({ icon, name, onClickHandler }: TPrivacyPolicyButton) => (
  <ButtonContainer id={`privacyPolicy-${name}`} onClick={onClickHandler}>
    <IconAndNameContainer>
      <InterSvgIcon width={20} height={20} iconRef={icon} color="var(--typography500)" />
      <Text variant="body-3" color="typography" colorWeight={500}>
        {name}
      </Text>
    </IconAndNameContainer>
    <InterSvgIcon
      width={24}
      height={24}
      iconRef="core/action-navigation/ic_chevron_right"
      color="var(--secondary500)"
    />
  </ButtonContainer>
)
